/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClaimDuplicationCheckPayloadDto
 */
export interface ClaimDuplicationCheckPayloadDto {
    /**
     * 
     * @type {string}
     * @memberof ClaimDuplicationCheckPayloadDto
     */
    insuredId: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimDuplicationCheckPayloadDto
     */
    lineOfBusiness: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimDuplicationCheckPayloadDto
     */
    subClass: string;
    /**
     * 
     * @type {Date}
     * @memberof ClaimDuplicationCheckPayloadDto
     */
    dateOfLoss: Date;
}

/**
 * Check if a given object implements the ClaimDuplicationCheckPayloadDto interface.
 */
export function instanceOfClaimDuplicationCheckPayloadDto(value: object): value is ClaimDuplicationCheckPayloadDto {
    if (!('insuredId' in value) || value['insuredId'] === undefined) return false;
    if (!('lineOfBusiness' in value) || value['lineOfBusiness'] === undefined) return false;
    if (!('subClass' in value) || value['subClass'] === undefined) return false;
    if (!('dateOfLoss' in value) || value['dateOfLoss'] === undefined) return false;
    return true;
}

export function ClaimDuplicationCheckPayloadDtoFromJSON(json: any): ClaimDuplicationCheckPayloadDto {
    return ClaimDuplicationCheckPayloadDtoFromJSONTyped(json, false);
}

export function ClaimDuplicationCheckPayloadDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimDuplicationCheckPayloadDto {
    if (json == null) {
        return json;
    }
    return {
        
        'insuredId': json['insuredId'],
        'lineOfBusiness': json['lineOfBusiness'],
        'subClass': json['subClass'],
        'dateOfLoss': (new Date(json['dateOfLoss'])),
    };
}

export function ClaimDuplicationCheckPayloadDtoToJSON(json: any): ClaimDuplicationCheckPayloadDto {
    return ClaimDuplicationCheckPayloadDtoToJSONTyped(json, false);
}

export function ClaimDuplicationCheckPayloadDtoToJSONTyped(value?: ClaimDuplicationCheckPayloadDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'insuredId': value['insuredId'],
        'lineOfBusiness': value['lineOfBusiness'],
        'subClass': value['subClass'],
        'dateOfLoss': ((value['dateOfLoss']).toISOString()),
    };
}

